import React, { useState } from 'react';
import API from '../../api-graphql';
import DocumentList from './DocumentList';
const Signer = (props) => {
  const [documents, setDocuments] = useState();

  const getAllDocuments = async (location) => {
    const data = await API.listDocumentsByEmail();

    const { listDocumentsByEmail: { items } } = data.data;

    const temporalDocuments = await items.map(elm => {
      return elm.document;
    });
    setDocuments(temporalDocuments);
  };

  return (
    <DocumentList documents={documents} getAllDocuments={getAllDocuments} />
  );
};
export default Signer;
